const apiBaseUrl = process.env.VUE_APP_API_URL;
const appName = process.env.VUE_APP_NAME;
const socketUrl = process.env.VUE_APP_SOCKET_URL;
const multiCompany = process.env.VUE_APP_MULTI_COMPANY;
const isGrantReviewPortal = process.env.VUE_APP_GRANT_REVIEW_PORTAL;
export { apiBaseUrl, appName, socketUrl, multiCompany, isGrantReviewPortal };
